import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const CallToAction = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 px-6 lg:px-8 bg-[#1E40AF]">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
          Bereit für deine neue Website?
        </h2>
        <p className="text-xl text-white/90 mb-10">
          Lass uns unverbindlich sprechen.
        </p>
        <Button
          onClick={scrollToContact}
          size="lg"
          className="bg-white hover:bg-gray-100 text-[#1E40AF] transition-all px-8 py-7 text-base font-semibold group"
        >
          Kontakt aufnehmen
          <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
        </Button>
      </div>
    </section>
  );
};

export default CallToAction;
